// extracted by mini-css-extract-plugin
export var searchHeader = "_7l-0";
export var searchHeaderDark = "_7l-1";